module.exports = "/_next/static/images/offers2-2x-0374dc23adc0a8e7ea3cc6f7bc6a4b33.jpg.webp";